import React, { useEffect, useState, useCallback } from 'react';
import { sharedAPI } from '../lib/walletApi';
import { Bell, Loader2 } from 'lucide-react';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger
} from '../components/ui/dropdown-menu';

export default function NotificationBell() {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const load = useCallback(async () => {
    try {
      const [notifs, count] = await Promise.all([
        sharedAPI.getNotifications({ page_size: 10 }),
        sharedAPI.getUnreadCount()
      ]);
      setNotifications(notifs);
      setUnreadCount(count.unread_count);
    } catch { /* */ }
  }, []);

  useEffect(() => { load(); const i = setInterval(load, 30000); return () => clearInterval(i); }, [load]);

  const handleMarkRead = async (id) => { try { await sharedAPI.markRead(id); load(); } catch {} };
  const handleMarkAllRead = async () => { try { await sharedAPI.markAllRead(); load(); } catch {} };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="relative p-2 rounded-lg hover:bg-gray-50 transition-colors" data-testid="notification-bell">
          <Bell className="w-5 h-5 text-gray-500" />
          {unreadCount > 0 && (
            <span className="absolute -top-0.5 -right-0.5 w-4 h-4 rounded-full bg-pink-500 text-[10px] text-white flex items-center justify-center font-bold">
              {unreadCount > 9 ? '9+' : unreadCount}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 border-gray-200 max-h-96 overflow-y-auto">
        <div className="flex items-center justify-between px-3 py-2 border-b border-gray-100">
          <span className="text-sm font-semibold text-gray-700">Notifications</span>
          {unreadCount > 0 && <button onClick={handleMarkAllRead} className="text-xs text-pink-500 hover:underline" data-testid="mark-all-read">Mark all read</button>}
        </div>
        {notifications.length === 0 ? (
          <div className="p-4 text-center text-gray-400 text-sm">No notifications</div>
        ) : notifications.map(n => (
          <DropdownMenuItem key={n.id} className={`px-3 py-2.5 cursor-pointer ${!n.is_read ? 'bg-pink-50/50' : ''}`}
            onClick={() => !n.is_read && handleMarkRead(n.id)}>
            <div className="flex items-start gap-2 w-full">
              {!n.is_read && <div className="w-2 h-2 rounded-full bg-pink-500 mt-1.5 shrink-0" />}
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-800 truncate">{n.title}</p>
                <p className="text-xs text-gray-500 line-clamp-2">{n.body}</p>
                <p className="text-[10px] text-gray-400 mt-1">{new Date(n.created_at).toLocaleString()}</p>
              </div>
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
